import { render } from "./ContentArea.vue?vue&type=template&id=ebf8245c&scoped=true&ts=true"
import script from "./ts/content/contentHelper.ts?vue&type=script&lang=ts"
export * from "./ts/content/contentHelper.ts?vue&type=script&lang=ts"

import "./ContentArea.vue?vue&type=style&index=0&id=ebf8245c&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf8245c"]])

export default __exports__